import { memo } from 'react';
import { useTheme } from 'styled-components';

import { Text } from '@desygner/ui-common-components';

import {
  StyledContainer,
  StyledGridItem,
  StyledInnerContainer,
  StyledLabel,
  StyledLabelContainer,
} from './GridPreview.style';

interface GridPreviewProps {
  row: number;
  column: number;
  selected?: boolean;
  onClick?: () => void;
}

export const GridPreview = memo(function GridPreview({
  row,
  column,
  selected,
  onClick,
}: GridPreviewProps): React.ReactElement {
  const borderWidth = 2;
  const label = row > 1 && column > 1 ? `${row}x${column}` : `${row * column}`;
  const theme = useTheme();

  return (
    <StyledContainer onClick={onClick} selected={selected}>
      <StyledInnerContainer column={column} row={row}>
        {Array.from({ length: row * column }).map((_, index) => {
          const borderTopWidth = index < column ? 0 : borderWidth / 2;
          const borderRightWidth = (index + 1) % column === 0 ? 0 : borderWidth / 2;
          const borderBottomWidth = index >= row * (column - 1) || row === 1 ? 0 : borderWidth / 2;
          const borderLeftWidth = index % column === 0 ? 0 : borderWidth / 2;

          return (
            <StyledGridItem
              key={index}
              borderTopWidth={`${borderTopWidth}px`}
              borderRightWidth={`${borderRightWidth}px`}
              borderBottomWidth={`${borderBottomWidth}px`}
              borderLeftWidth={`${borderLeftWidth}px`}
            />
          );
        })}
      </StyledInnerContainer>

      <StyledLabelContainer>
        <StyledLabel selected={selected}>
          <Text color={selected ? theme.Color.Brand.Primary : undefined} size="Body">
            {label}
          </Text>
        </StyledLabel>
      </StyledLabelContainer>
    </StyledContainer>
  );
});
